import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';

const TermosUso = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Button
              onClick={() => navigate(-1)}
              variant="ghost"
              className="rounded-xl p-2"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                <FileText className="w-5 h-5 text-primary" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Termos de Uso</h1>
                <p className="text-sm text-gray-500">Última atualização: Abril de 2026</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 md:p-10">
          <div className="prose prose-gray max-w-none">
            
            <h2>1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e utilizar a plataforma <strong>Lembrou?</strong> ("Plataforma"), você concorda 
              em cumprir e estar vinculado aos seguintes Termos de Uso. Se você não concordar com 
              qualquer parte destes termos, não deverá utilizar nossa Plataforma.
            </p>

            <h2>2. Descrição do Serviço</h2>
            <p>
              O <strong>Lembrou?</strong> é uma plataforma de gestão de lembretes automáticos que permite:
            </p>
            <ul>
              <li>Cadastro e gerenciamento de lembretes de vencimento de serviços e contratos</li>
              <li>Envio automático de notificações por email e WhatsApp</li>
              <li>Geração de QR Codes para cadastro de clientes</li>
              <li>Importação de dados via CSV/Excel</li>
              <li>Relatórios e métricas de acompanhamento</li>
            </ul>

            <h2>3. Cadastro e Conta</h2>
            <p>
              Para utilizar o <strong>Lembrou?</strong>, você deve:
            </p>
            <ul>
              <li>Ter pelo menos 18 anos de idade ou capacidade legal para contratar</li>
              <li>Fornecer informações verdadeiras, precisas e completas durante o cadastro</li>
              <li>Manter suas credenciais de acesso em sigilo</li>
              <li>Ser responsável por todas as atividades realizadas em sua conta</li>
            </ul>
            <p>
              O <strong>Lembrou?</strong> reserva-se o direito de suspender ou encerrar contas que 
              violem estes Termos de Uso ou que apresentem informações falsas.
            </p>

            <h2>4. Planos e Pagamentos</h2>
            <p>
              O <strong>Lembrou?</strong> oferece diferentes planos de serviço:
            </p>
            <ul>
              <li><strong>Plano FREE:</strong> Gratuito, com limite de 20 lembretes ativos e envio apenas por email.</li>
              <li><strong>Plano PRO:</strong> Pago mensalmente (R$ 19,99/mês), com lembretes ilimitados, 
                envio por WhatsApp e email, importação de arquivos e recursos avançados.</li>
            </ul>
            <p>
              Os pagamentos são processados através do <strong>Stripe</strong>, uma plataforma de 
              pagamentos segura. Ao fornecer dados de pagamento, você concorda com os termos do Stripe.
            </p>
            <p>
              A renovação do plano PRO é automática. Você pode cancelar a qualquer momento através 
              do seu perfil, e o acesso será mantido até o final do período pago.
            </p>

            <h2>5. Uso Aceitável</h2>
            <p>
              Você concorda em utilizar o <strong>Lembrou?</strong> apenas para fins legais e de acordo 
              com estes Termos. É proibido:
            </p>
            <ul>
              <li>Usar a Plataforma para enviar spam ou mensagens não solicitadas</li>
              <li>Cadastrar dados falsos ou de terceiros sem autorização</li>
              <li>Tentar acessar áreas restritas ou sistemas não autorizados</li>
              <li>Utilizar scripts, bots ou ferramentas automatizadas não autorizadas</li>
              <li>Violar direitos de propriedade intelectual</li>
              <li>Praticar qualquer atividade ilegal ou prejudicial</li>
            </ul>

            <h2>6. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo da Plataforma, incluindo mas não limitado a textos, gráficos, logos, 
              ícones, imagens, código-fonte e software, é de propriedade exclusiva do <strong>Lembrou?</strong> 
              ou de seus licenciadores, sendo protegido por leis de direitos autorais e propriedade intelectual.
            </p>

            <h2>7. Limitação de Responsabilidade</h2>
            <p>
              O <strong>Lembrou?</strong> é fornecido "como está" e "conforme disponível". Não garantimos que:
            </p>
            <ul>
              <li>O serviço será ininterrupto ou livre de erros</li>
              <li>Os resultados obtidos serão precisos ou confiáveis</li>
              <li>Todas as mensagens serão entregues com sucesso</li>
            </ul>
            <p>
              Em nenhuma circunstância o <strong>Lembrou?</strong> será responsável por danos indiretos, 
              incidentais, especiais ou consequentes decorrentes do uso ou impossibilidade de uso da Plataforma.
            </p>

            <h2>8. Modificações nos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. 
              Alterações significativas serão comunicadas por email ou através da Plataforma. 
              O uso continuado após as modificações constitui aceitação dos novos termos.
            </p>

            <h2>9. Rescisão</h2>
            <p>
              Você pode encerrar sua conta a qualquer momento. O <strong>Lembrou?</strong> também pode 
              suspender ou encerrar seu acesso em caso de violação destes Termos, sem aviso prévio.
            </p>

            <h2>10. Lei Aplicável e Foro</h2>
            <p>
              Estes Termos são regidos pelas leis da República Federativa do Brasil. 
              Fica eleito o foro da comarca de São Paulo/SP para dirimir quaisquer controvérsias 
              decorrentes destes Termos, com renúncia a qualquer outro, por mais privilegiado que seja.
            </p>

            <h2>11. Contato</h2>
            <p>
              Em caso de dúvidas sobre estes Termos de Uso, entre em contato conosco:
            </p>
            <ul>
              <li><strong>Email:</strong> contato@lembrou.com.br</li>
              <li><strong>Site:</strong> https://lembrou.com.br</li>
            </ul>

            <div className="mt-8 p-4 bg-gray-50 rounded-xl border border-gray-200">
              <p className="text-sm text-gray-600 mb-0">
                Ao utilizar o <strong>Lembrou?</strong>, você declara ter lido, compreendido e concordado 
                com estes Termos de Uso em sua totalidade.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-6 mt-8">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-gray-500">
            © 2026 Lembrou? — Todos os direitos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermosUso;
